<template>
  <v-card class="p-5">
    <b-form @submit.prevent="onSubmit" >
      <div class="row d-flex justify-content-between align-items-center">
        <!-- left -->
        <div class="col-lg-6">
          <!-- <div class="row item d-flex justify-content-center mb-6 p-3"> -->
            <div id="image" class="d-flex justify-content-center flex-column align-items-center mb-4">
            <div id="preview" class="mb-2">
              <img v-if="url" :src="url" height="200" width="150" />
              <div v-else style="height: 200px; width: 150px; background-color: #D9D9D9"></div>
            </div>
            <div>
              <input id="img_upload" ref="file" type="file" @change="onFileChange" accept="image/*"
                style="display: none" />
              <ButtonComponent class="mb-6" onclick="document.getElementById('img_upload').click()"
                style="border: 1px solid #3751E4;" colors="white" name="camera-profil" title="Ganti Foto Profil"
                dataTitleTooltip="Ganti Foto Profil" />
            </div>
          </div>
          <!-- </div> -->
          <div class="row d-flex justify-content-between align-items-center">
            <div class="col-lg-4">
              <label class="form-label">Jalan</label>
            </div>
            <div class="col-lg-8">
              <b-form-input v-model="request.phone" type="text"
                placeholder="Masukkan Nomor Ponsel" onkeypress='return event.charCode >= 48 && event.charCode <= 57'></b-form-input>
            </div>
          </div>
          <div class="row d-flex justify-content-between align-items-center">
            <div class="col-lg-4">
              <label class="form-label">Desa/Kelurahan</label>
            </div>
            <div class="col-lg-8">
              <SelectComponent :data="rank" :changeSelected="changePangkat" :models="request.rank"
               :placeholder="`Pilih Pangkat`">
            </SelectComponent>
            </div>
          </div>
          <div class="row d-flex justify-content-between align-items-center" style="margin-top: -1%;">
            <div class="col-lg-3">
              <label class="form-label">Wilayah</label>
            </div>
            <div class="col-lg-8">
              <SelectComponent :data="statusProdi" :changeSelected="changeStatusProdi" :models="selectedStatusProdi" 
                :placeholder="`Pilih Status`"></SelectComponent>
            </div>
          </div>
          <div class="row d-flex justify-content-between align-items-center" style="margin-top: -1%;" v-if="selectedStatusProdi">
            <div class="col-lg-3">
              <label class="form-label">Diklat Homebased</label>
            </div>
            <div class="col-lg-8">
              <SelectProdiAll :selectedValue="request.prodi_homebased" :changeprodi="changeHomeBased"
                :placeholder="`Pilih Diklat`"></SelectProdiAll>
            </div>
          </div>
        </div>

        <!-- right -->
        <div class="col-lg-6">

          <div class="row d-flex justify-content-between align-items-center">
            <div class="col-lg-4">
              <label class="form-label">Nama</label>
            </div>
            <div class="col-lg-8">
              <b-form-input v-model="request.name" type="text" required placeholder="Masukkan Nama"></b-form-input>
            </div>
          </div>
          <div class="row d-flex justify-content-between align-items-center">
            <div class="col-lg-4">
              <label class="form-label">NIDN</label>
            </div>
            <div class="col-lg-8">
              <b-form-input v-model="request.NIDN" type="text" placeholder="Masukkan NIDN" onkeypress='return event.charCode >= 48 && event.charCode <= 57'></b-form-input>
            </div>
          </div>
          <div class="row d-flex justify-content-between align-items-center">
            <div class="col-lg-4">
              <label class="form-label">NRP/ NIP</label>
            </div>
            <div class="col-lg-8">
              <b-form-input v-model="request.NRP" type="text" placeholder="Masukkan NRP/ NIP"></b-form-input>
            </div>
          </div>
          <div class="row d-flex justify-content-between align-items-center">
            <div class="col-lg-3">
              <label class="form-label">Jenis Kelamin</label>
            </div>
            <div class="col-lg-8">
              <b-form-radio-group id="pilihStatusDosen">
                <b-form-radio v-model="request.gender" value="male">Laki - laki</b-form-radio>
                <b-form-radio v-model="request.gender" value="female">Perempuan</b-form-radio>
              </b-form-radio-group>
            </div>
          </div>
          <div class="row d-flex justify-content-between align-items-center">
            <div class="col-lg-4">
              <label class="form-label">Tempat Lahir</label>
            </div>
            <div class="col-lg-8">
              <b-form-input v-model="request.pob" type="text" placeholder="Masukkan Tempat Lahir"></b-form-input>
            </div>
          </div>
          <div class="row d-flex justify-content-between align-items-center">
            <div class="col-lg-4">
              <label class="form-label">Tanggal Lahir</label>
            </div>
            <div class="col-lg-8">
              <b-form-input v-model="request.dob" type="date"></b-form-input>
            </div>
          </div>
          <div class="row d-flex justify-content-between align-items-center">
            <div class="col-lg-4">
              <label class="form-label">Email</label>
            </div>
            <div class="col-lg-8">
              <b-form-input v-model="request.email" type="email" required placeholder="Masukkan Email"></b-form-input>
            </div>
          </div>
          <div class="row d-flex justify-content-between">
            <div class="col-lg-4">
              <label class="form-label">Alamat</label>
            </div>
            <div class="col-lg-8">
              <b-form-textarea v-model="request.address" rows="3" no-resize
                placeholder="Masukkan Alamat"></b-form-textarea>
            </div>
          </div>
          <div class="row d-flex justify-content-between align-items-center">
            <div class="col-lg-4">
              <label class="form-label">RT</label>
            </div>
            <div class="col-lg-2">
              <Select2 v-model="request.prodi_diajar" :options="prodiDiajarOptions" :searchable="true"
                :settings="{ multiple: true, width: '100%' }" :placeholder="`Pilih Diklat`" />
            </div>
            <div class="col-lg-3">
              <label class="form-label">RW</label>
            </div>
            <div class="col-lg-3">
              <Select2 v-model="request.prodi_diajar" :options="prodiDiajarOptions" :searchable="true"
              :settings="{ multiple: true, width: '100%' }" :placeholder="`Pilih Diklat`" />
            </div>
          </div>
          <div class="row d-flex justify-content-between">
            <div class="col-lg-4">
              <label class="form-label">Kode Pos</label>
            </div>
            <div class="col-lg-8">
              <b-form-textarea v-model="request.address" rows="3" no-resize
                placeholder="Masukkan Alamat"></b-form-textarea>
            </div>
          </div>
          
        </div>

      </div>
      <div class="row" style="margin-top: 5%;">
        <div class="col-lg-6"></div>
        <div class="col-lg-6" style="display: flex;">
          <b-button type="submit" variant="outline-primary" style="margin-left: auto;">Simpan</b-button>
          <b-button type="reset" @click="$router.push({ name: 'Daftar-Dosen' })" variant="outline-danger" class="ml-2" style="margin-left: auto;">Batal</b-button>
        </div>
      </div>

    </b-form>
  </v-card>
</template>

<script>
import axios from "axios"
import SelectProdiAll from "@/view/content/components/select/SelectProdiAll.vue"
import ButtonComponent from "@/view/content/components/button/buttonComponent.vue";
// import Select2 from 'v-select2-component';
import SelectComponent from "@/view/content/components/select/SelectComponent.vue";


export default {
  statusModal: '',
  props: {
    dataEdit: {
      type: Object,
    },
  },
  components: {
    SelectProdiAll,
    ButtonComponent,
    // Select2,
    SelectComponent
  },
  data() {
    return {
      request: {
        key: null,
        name: null,
        lecturer_id: (JSON.parse(window.localStorage.dataLogin).key_dosen) ? JSON.parse(window.localStorage.dataLogin).key_dosen : null,
        pob: null,
        dob: null,
        address: null,
        rank: null,
        gender: null,
        email: null,
        phone: null,
        prodi_homebased: null,
        prodi_diajar: [],
        portrait: null,
        NIDN: null,
        NRP: null,
        NIP: null
      },
      props: this.$props.dataEdit ? this.$props.dataEdit : null,
      prodiDiajarOptions: [
        { 'id': null, 'text': '-- Pilih Diklat --' }
      ],
      rank: [],
      file: null,
      url: null,
      isSelecting: false,
      statusProdi: [
        { id: false, text: 'Non Diklat' },
        { id: true, text: 'Diklat' },
      ],
      selectedStatusProdi: false,
    }
  },
  computed: {
    key_dosen() {
      return this.$route.params != null ? this.$route.params.key : null
    }
  },
  methods: {
    changePangkat: function (selected) {
      this.request.rank = selected;
    },

    onFileChange(e) {
      const file = e.target.files[0];
      this.url = URL.createObjectURL(file);
      this.file = this.$refs.file.files[0];
    },

    containsOnlyNumbers(str) {
      return /^\d+$/.test(str);
    },
    onSubmit() {
      const form = this.request;
      // if (this.containsOnlyNumbers(form.NIDN) == false && this.containsOnlyNumbers(form.phone) == false) {
      // if (form.phone !== null) {
      //   if (this.containsOnlyNumbers(form.phone) == false) {
      //     this.$swal(`No HP Harus Angka`);
      //   // } else if (this.containsOnlyNumbers(form.NIDN) == false) {
      //   //   this.$swal(`NIDN Harus Angka`);
      //   } else if (this.containsOnlyNumbers(form.phone) == false) {
      //     this.$swal(`No HP Harus Angka`);
      //   }
      // } else {
        let dosen = '';
        if (!this.key_dosen) {
          let dataLogin = JSON.parse(window.localStorage.dataLogin);
          dosen = dataLogin.key_dosen; 
        }else{
          dosen = this.key_dosen;
        }
        form.lecturer_id = dosen
        if (form.key === null) {
          // store
          this.store(form);
        } else {
          // update
          this.update(form);
        }
      // }

    },
    async store(form) {
      const formData = new FormData()
      formData.append("portrait", this.file);
      formData.append("name", form.name);
      formData.append("lecturer_id", form.lecturer_id);
      formData.append("field_id", "8ac73465-fa8f-4387-9047-d5a154377836");
      formData.append("pob", form.pob);
      formData.append("dob", (form.dob)? form.dob : 'null');
      formData.append("NIDN", (form.NIDN) ? form.NIDN : '');
      formData.append("nrp", form.NRP);
      formData.append("address", (form.address) ? form.address : '');
      formData.append("rank", (form.rank)? form.rank : '');
      formData.append("gender", form.gender);
      formData.append("email", form.email);
      formData.append("phone", (form.phone) ? form.phone : '');
      if (this.selectedStatusProdi) {
        formData.append("prodi_homebased", form.prodi_homebased);
      }
      // for (var i = 0; i < form.prodi_diajar; i++) {
      //   formData.append('prodi_diajar[]', form.prodi_diajar[i]);
      // }
      
      const result = await axios.post(`master/lecturer/`, formData)
      let id_store = result.data.data
      if (result.data.meta.code == 200) {
        this.$swal({
            title: 'Success Store Data',
            confirmButtonText: 'OK',
            confirmButtonColor: '#3085d6',
          }).then(async (result) => {
            if (result.value) {
              // User confirmed
              this.$router.push({
                path: id_store,
                params: { createOrUpdate: "Sukses Store Data" },
              });
              window.location.reload();
            } else {
              // User canceled, so do nothing
            }
          })
      } else {
        await this.$swal(`${result.data.meta.message}`);
      }
    },
    async update(form) {
      const formData = new FormData()
      if (this.file !== null) {
        formData.append("portrait", this.file);
      }
      formData.append("name", form.name);
      formData.append("lecturer_id", form.lecturer_id);
      formData.append("field_id", "8ac73465-fa8f-4387-9047-d5a154377836");
      formData.append("pob", form.pob);
      formData.append("dob", form.dob);
      formData.append("NIDN", (form.NIDN) ? form.NIDN : '');
      formData.append("nrp", form.NRP);
      formData.append("address", form.address);
      formData.append("rank", form.rank);
      formData.append("gender", form.gender);
      formData.append("email", form.email);
      formData.append("phone", form.phone);
      if (this.selectedStatusProdi) {
        formData.append("prodi_homebased", form.prodi_homebased);
      }
      // formData.append("prodi_diajar", form.prodi_diajar);
      // for (var i = 0; i < form.prodi_diajar; i++) {
      //   formData.append('prodi_diajar[]', form.prodi_diajar[i]);
      // }
      // for (var i = 0; i < form.prodi_diajar.length; i++) {
      // }

      const result = await axios.post(`master/lecturer/${form.key}`, formData)

      if (result.data.meta.code == 200) {
        // this.$router.push({ name: 'master-lecturer', params: { createOrUpdate: 'Sukses Update Data' } });
        this.$swal(`Success Update Data`);
      } else {
        await this.$swal(`${result.data.meta.message}`);
      }
    },
    changeStatusProdi(selected) {
      this.selectedStatusProdi = selected === 'true'
    },
    async changeHomeBased(selected) {
      this.request.prodi_homebased = selected
      this.prodiDiajarOptions = [
        { 'id': null, 'text': '-- Pilih Diklat --' }
      ]
      await this.getProdiDiajarOptions(selected)
    },
    async getProdiDiajarOptions(prodi_id) {
      await axios.get('master/study-programs')
        .then(response => {
          if (response.status == 200) {
            response.data.data.some((e, index) => {
              if (e.key != prodi_id) {
                var object = { "id": e.key, "text": e.program_name }
                this.prodiDiajarOptions.push(object);
              }
              return index > e.length;
            });
          }
        })
    },

    async getPangkat() {
      await axios.get("master/rank?status=true")
      .then((response) => {
        if (response.status == 200) {
          //sorting
          response.data.data.sort((a, b) => {
            if (a.urutan < b.urutan) return -1;
            if (a.urutan > b.urutan) return 1;
            return 0;
          });
          //aal 
          response.data.data.map((e, index) => {
            if (e.kategori === 'Personil TNI AL' ){
              var object = { "text": e.rank, "id": e.key }
              this.rank.push(object);
              return index > e.length;
            }
          });
          //pns
          response.data.data.map((e, index) => {
            if (e.kategori === 'PNS' ){
              var object = { "text": e.rank, "id": e.key }
              this.rank.push(object);
              return index > e.length;
            }
          });
        }
      });
    },

  },
  async mounted() {
    if (this.key_dosen === 'add') {
      this.request.portrait = null
      this.request.key = null
      this.request.name = null
      this.request.lecturer_id = null
      this.request.pob = null
      this.request.dob = null
      this.request.address = null
      this.request.rank = null
      this.request.gender = null
      this.request.email = null
      this.request.phone = null
      this.request.prodi_homebased = null
      this.request.prodi_diajar = null
      this.request.NIDN = null
      this.request.NRP = null
      this.request.NIP = null
    } else {
      let dosen = '';
      if (!this.key_dosen) {
        let dataLogin = JSON.parse(window.localStorage.dataLogin);
        dosen = dataLogin.key_dosen; 
      }else{
        dosen = this.key_dosen;
      }
      const result = await axios.get(`master/lecturer/${dosen}/detail/`)
      if (result.data.data[0].portrait === undefined || result.data.data[0].portrait === null) {
        this.url = ''
      } else if (result.data.data[0].portrait != "") {
        this.url = this.$endpoint +  'uploads/lecturer_portrait/' + result.data.data[0].portrait
      }
      // this.file = result.data.data[0].portrait
      this.request.portrait = result.data.data[0].portrait
      this.request.key = result.data.data[0].id_user
      this.request.name = result.data.data[0].name
      // this.request.lecturer_id = result.data.data[0].nidn
      if (result.data.data[0].nidn == 'null') {
        this.request.NIDN = ''
      } else {
        this.request.NIDN = result.data.data[0].nidn
      }
      if (result.data.data[0].nrp == 'null') {
        this.request.NRP = ''
      } else {
        this.request.NRP = result.data.data[0].nrp
      }
      if (result.data.data[0].nip == 'null') {
        this.request.NIP = ''
      } else {
        this.request.NIP = result.data.data[0].nip
      }
      this.request.pob = result.data.data[0].place_of_birth
      this.request.dob = result.data.data[0].date_of_birth
      if (result.data.data[0].address == "null") {
        this.request.address = ""
      } else{ 
        this.request.address = result.data.data[0].address
      }
      this.request.rank = result.data.data[0].rank_key
      this.request.gender = result.data.data[0].gender
      this.request.email = result.data.data[0].email
      if (result.data.data[0].phone == "null") {
        this.request.phone = ""
      } else{ 
        this.request.phone = result.data.data[0].phone
      }
      this.request.prodi_homebased = result.data.data[0].prodi_homebased
      await this.getProdiDiajarOptions(result.data.data[0].prodi_homebased)
      result.data.data[0].prodi_diajar.forEach(element => this.request.prodi_diajar.push(element.key_prodi));
      if (this.request.prodi_homebased != null) {
        this.selectedStatusProdi = true
      }
    }
     this.getPangkat();
  }
}
</script>